module.exports = __webpack_public_path__ + "img/hall2.e52863ad.jpg";